/* unplugin-vue-components disabled */import script from "./Cyhd.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cyhd.vue?vue&type=script&lang=ts&setup=true"

import "./Cyhd.vue?vue&type=style&index=0&id=6863e765&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6863e765"]])

export default __exports__